<script setup>
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    default: '-',
  },
  type: {
    type: String,
    default: 'default',
    validator: value =>
      ['default', 'success', 'warning', 'danger'].includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const typeClasses = {
  default: 'text-n-slate-12',
  success: 'text-n-green-11',
  warning: 'text-n-amber-11',
  danger: 'text-n-ruby-11',
};
</script>

<template>
  <div
    class="flex flex-col p-4 rounded-xl bg-n-solid-2 shadow outline-1 outline outline-n-container min-h-[8rem]"
  >
    <span class="text-sm text-n-slate-11 mb-2">{{ title }}</span>
    <div v-if="isLoading" class="flex items-center justify-center flex-1">
      <Spinner />
    </div>
    <template v-else>
      <span class="text-3xl font-semibold" :class="typeClasses[type]">
        {{ value }}
      </span>
      <span v-if="subtitle" class="text-xs text-n-slate-10 mt-1">
        {{ subtitle }}
      </span>
    </template>
  </div>
</template>
